import React, { useState, useEffect, useRef } from 'react';
import styled from 'styled-components';
import * as XLSX from 'xlsx';
import ExcelJS from 'exceljs';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import moment from 'moment-timezone';
import { fetchVisitorTypes, fetchIdProofTypes, fetchMeetingVenues, insertAppointment, fetchGateDetails, fetchNationality, fetchBuildingsByGate } from '../../services/Api';
import Webcam from 'react-webcam'; // Import react-webcam
import { User } from 'react-feather'; // Import the User icon
import { SelfieSegmentation } from '@mediapipe/selfie_segmentation';
import { axiosInstance } from '../../services/Api';
import Loader from '../../Loader/loader';
import { FiEdit } from 'react-icons/fi'; // Using react-icons library
import { FaceDetection } from '@mediapipe/face_detection';

const Container = styled.div`
  padding: 28px;
  display: flex;
  flex-direction: column;
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-bottom:0px; /* Adjusted margin-bottom for spacing */
`;

const Heading = styled.h1`
  font-size: 22px;
  font-family: 'Segoe UI', 'Semibold';
      color:#2B3497;
  
`;

const ButtonsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

const ButtonGroupLeft = styled.div`
  display: flex;
  gap: 10px; /* Space between buttons */
`;

const ButtonGroupRight = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 10px; /* Space between buttons */
`;

const Button = styled.button`
  background-color: #2B3497;
  color: #FFF;
  box-shadow: 0px 5px 10px #2B349754;
  border-radius: 12px;
  opacity: 1;
  padding: 10px 20px;
  border: none;
  cursor: pointer;
  font-size: 14px;
  &:hover {
    background-color: #1E2A6D;
  }
  &:active {
    background-color: #162055;
  }
`;
const ScrollableTableContainer = styled.div`
  margin-top:15px;
  max-height: 500px; /* Set the desired height */
  overflow-y: auto; /* Enable vertical scrolling */
  overflow-x: hidden; /* Disable horizontal scrolling */
  border: 1px solid #ddd; /* Optional: Add a border for better visibility */
`;
const TableContainer = styled.div`
  overflow-x: auto;
  margin-top: 20px;
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  background: linear-gradient(to bottom, #E6E6E6, #F2F2F2, #F5F5F5, #F3F3F3, #E9E9E9);
  box-shadow: 0px 10px 20px #0000001A;
  border-radius: 6px;
  opacity: 1;
`;

const TableHeader = styled.thead`
  background: linear-gradient(to bottom, #E6E6E6, #F2F2F2, #F5F5F5, #F3F3F3, #E9E9E9);
  color: #000;
`;

const TableRow = styled.tr`
  text-align: left;
`;
const IconWrapper = styled.span`
  cursor: pointer;
  color: #2B3497;
  margin: 0 5px;
`;

const TableHeaderCell = styled.th`
  padding: 10px;
  text-align: left;
  white-space: nowrap;
  &:first-child {
    border-top-left-radius: 10px;
  }
  &:last-child {
    border-top-right-radius: 10px;
  }
`;

const TableBody = styled.tbody``;

const TableCell = styled.td`
  padding: 10px;
  border-bottom: 1px solid #ddd;
  white-space: nowrap;
`;

const Popup = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
   background: #fff;
    box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.3);
    border-radius: 10px;
  padding: 30px;
  text-align: center;
  opacity: 1;
  z-index: 1000;
  width: 500px;
  height: auto; /* Use auto height to fit content */
  display: flex;
  flex-direction: column;
  justify-content: space-between; /* Push content and buttons to the top/bottom */
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end; /* Align buttons to the right */
  margin-top: 20px; /* Add some space between content and buttons */
`;

const PopupButton = styled.button`
  background-color: #2B3397;
  color: #fff;
  font-size: 16px;
  padding: 10px 20px;
  border: none;
  border-radius: 12px;
  box-shadow: 0px 10px 20px #2B349754;
  opacity: 1;
  cursor: pointer;
  margin-left: 10px; /* Add space between buttons */
`;

const PopupText = styled.p`
  font-size: 20px;
  color: #2B3497;
  margin-bottom: 20px;
  font-weight:700;
`;

const LabelValueContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 15px;
`;

const Label = styled.label`
  font-weight: 600;
  font-size: 16px;
  color: #000;
  width: 40%; /* Control label width */
  text-align: left; /* Ensure label is aligned to the left */
//   &::after {
//     content: '*';
//     color: red;
//     margin-left: 5px;
//   }
`;
const Asterisk = styled.span`
  color: red;
`;

const Value = styled.span`
  font-size: 16px;
  color: #000;
  width: 55%; /* Control value width */
  text-align: right; /* Ensure value is aligned to the right */
`;

// Dropdown styles
const DropdownContainer = styled.div`
  margin-top: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const DropdownLabel = styled.label`
  font-weight: 400;
  font-size: 16px;
  color: #000;
  width: 40%; /* Same as Label width */
  text-align: left;
`;

const StyledDropdown = styled.select`
  padding: 10px;
  border: 1px solid #d3d3d3;
  border-radius: 4px;
  background-color: #f9f9f9;
  width: 48%; /* Same as Value width */
  text-align: left;
  cursor: pointer;
  transition: border-color 0.3s ease;

  &:focus {
    border-color: #293495;
    outline: none;
  }

  option {
    padding: 8px;
  }
`;
const Input = styled.input`
  width:160px;
  border: none;
  border-bottom: 2px solid #3d46b4;
  background: transparent;
  padding: 10px;
  font-size: 16px;
  outline: none;
  flex: 1;
    margin-right: 20px; // Space to the right of the dropdown
    /* Remove up and down arrows for number input */
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  &::-moz-appearance {
    textfield;
  }

`;
const Dropdown = styled.select`
width:175px;
border: none;
border-bottom: 2px solid #3d46b4;
font-size: 15px !important;
padding: 10px;
background: transparent;
font-family: 'Segoe UI', Regular;
outline: none; /* Remove default focus outline */
margin-right: 24px; // Space to the right of the dropdown
flex: 1; // Makes the dropdown take up more space
`;
const Card = styled.div`
  background-color: #f5f5f5;
  box-shadow: 0px 5px 10px #00000038;
  border-radius: 10px;
  padding: 20px;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 20px;
`;
const CardLeft = styled.div`
  display: flex;
  flex-direction: column;
  width: 30%;
`;

const CardCenter = styled.div`
  display: flex;
  flex-direction: column;
  width: 30%;
`;

const CardRight = styled.div`
  display: flex;
  flex-direction: column;
  width: 30%;
`;

const CardItem = styled.div`
  margin-bottom: 10px;
`;

const CardLabel = styled.span`
  font-weight: bold;
  color: #333;
`;

const CardValue = styled.span`
  margin-left: 5px;
  color: #666;
`;

const WebcamContainer = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  width: 100%;
  height: 100%;
  transform: translate(-50%, -50%);
  border-radius: 50%;
  overflow: hidden;
`;
const ButtonRow = styled.div`
  display: flex;
  gap: 2px; /* Adjust gap between buttons */
  margin-bottom: 0px; /* Optional: Adjust margin bottom */
`;
const PhotoButton = styled.button`
  width: 79px;
  height: 35px;
  background-color: #343d9b;
  box-shadow: 0px 10px 10px #2b349733;
  border: 2px solid #343d9b;
  border-radius: 8px;
  opacity: 1;
  color: #ffffff;
  cursor: pointer;
  margin-bottom: 20px;
  font-size:9px;
`;

const ActionButton = styled.button`
  width: 79x;
  height: 35px;
  background-color: transparent;
  border: 2px solid #343d9b;
  border-radius: 8px;
  box-shadow: 0px 10px 10px #2b349733;
  opacity: 1;
  cursor: pointer;
  margin-bottom: 20px;
           @media (max-width: 1420px) and (min-width: 1220px) {
  width: 125px;

  }
              @media (max-width: 1220px) and (min-width: 1020px) {
  width: 100px;

  }
`;
const Circle = styled.div`
  width: 60px;
  height: 60px;
  background: linear-gradient(#ffffff, #f6f6f6);
  border-radius: 50%;
  box-shadow: 0px 10px 10px #00000024;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  margin:14px 44px;
`;

const ProfileIcon = styled.div`
  width: 60px;
  height: 60px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #2b3497;
  font-size: 30px;
  font-weight: bold;
  position: relative;
`;

const PlusIcon = styled.div`
  width: 47px;
  height: 23px;
  border-radius: 50%;
  position: absolute;
  right: 0;
  bottom: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #BFBFBF;
  font-size: 44px;
  font-weight: 700;
`;

const ProfileText = styled.div`
  font-family: 'Segoe UI', Semibold;
  font-size: 18px;
  color: #ff3030;
  margin-bottom: 20px;
`;


// Tabs container
const Tabs = styled.div`
  display: flex;
  border-bottom: 2px solid #ccc;
  margin-bottom: 20px;
`;

const Tab = styled.button`
  background: none;
  border: none;
  font-family: 'Segoe UI', Semibold;
  padding: 10px 20px;
  cursor: pointer;
  border-bottom: 2px solid transparent;
  color: #000;
  &:hover {
    color: #2B3497;
  }
  ${({ active }) => active && `
    border-bottom: 2px solid #2B3497;
    color: #2B3497;
  `}
`;

const TabContent = styled.div`
  display: ${({ active }) => (active ? 'block' : 'none')};
`;

//css file acknowlaged
const AckItem = styled.label`
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 20px 12px;
  margin-bottom: 10px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  background: #fafafa;
  cursor: pointer;
  transition: background 0.2s ease;

  &:hover {
    background: #f0f4ff;
  }

  input {
    margin-top: 3px;
    cursor: pointer;
  }
`;

const AckText = styled.span`
  font-size: 14px;
  color: #333;
  line-height: 1.4;

  a {
    color: #293495;
    font-weight: 500;
    text-decoration: underline;
  }
`;



const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-top: 10px;
  background: linear-gradient(
    to right,
    #e6e6e6,
    #f2f2f2,
    #f5f5f5,
    #f3f3f3,
    #e9e9e9
  );
  box-shadow: 0px 10px 20px #0000001a;
  border-radius: 10px;
`;



const PdfModalOverlay = styled.div`
  position: fixed;
  top: 0; 
  left: 0;
  width: 100%; 
  height: 100%;
  background: rgba(0,0,0,0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
`;

const PdfModalContent = styled.div`
  background: #fff;
  padding: 20px;
  width: 80%;
  max-width: 900px;
  border-radius: 12px;
  box-shadow: 0px 10px 20px #0000001a;
  position: relative;
  display: flex;
  flex-direction: column;
`;

const CloseButtonIcon = styled.button`
  position: absolute;
  top: 4px; 
  right: 15px;
  border: none;
  background: transparent;
  font-size: 20px;
  font-weight: bold;
  cursor: pointer;
  color: #293495;
`;

const PdfFrame = styled.iframe`
  width: 100%;
  height: 80vh;
  border: none;
  margin-top: 10px;
`;

const AgreeButton = styled.button`
  margin-top: 15px;
  align-self: flex-end;
  padding: 10px 18px;
  background: #293495;
  color: #fff;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: background 0.2s ease;

  &:hover {
    background: #1f276f;
  }
`;

const FileUploadContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

const HiddenFileInput = styled.input`
  display: none;
`;

const CustomFileButton = styled.button`
  background-color: #293495;
  color: #ffffff;
  padding: 8px 16px;
  font-size: 14px;
  font-family: 'Segoe UI', Semibold;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: 0.3s;

  &:hover {
    background-color: #1f2875;
  }
`;

const FileNameInput = styled.input`
  flex: 1;
  padding: 8px;
  border: none;
  border-bottom: 1px solid #2b3497;
  font-family: 'Segoe UI', Regular;
  background: transparent;
  color: #000;

  &:focus {
    outline: none;
    border-bottom: 2px solid #2b3497;
  }
`;

const CardContainer = styled.div`
  display: flex;
  justify-content: space-around;
  gap: 20px;
  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

const CloseButton = styled.button`
  background-color: #293495;
  color: white;
  padding: 5px 10px;
  border: none;
  border-radius: 5px;
  cursor: pointer;

  &:hover {
    background-color: #ff3030;
  }
`;
const CardAck = styled.div`
  flex: 1;
  background: #fff;
    box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.3);
    border-radius: 10px;
  padding: 27px;
  opacity: 1;
  @media (max-width: 768px) {
    width: 100%;
    margin-bottom: 20px;
  }
`;


const GroupMemberApplicationPage = () => {
    const navigate = useNavigate(); // Initialize useNavigate hook
    const location = useLocation();
    const { formattedData } = location.state || {};
    const { formDataAdditional } = location.state || {};

    const fileInputRef = useRef(null);
    const [tableData, setTableData] = useState([]);
    const [file, setFile] = useState(null); // Store the chosen file
    const [fileUploaded, setFileUploaded] = useState(false); // Track if the file has been uploaded
    const [nationalityListM, setNationalityListM] = useState([]);
    const [loading, setLoading] = useState(false); // Global loading state
    const normalizeValue = (val) => (val || '').toString().trim().toLowerCase();

    const getMemberSignature = (row) => {
        const firstName = normalizeValue(row['firstName']);
        const lastName = normalizeValue(row['lastName']);
        const email = normalizeValue(row['email']);
        return `${firstName}|${lastName}|${email}`;
    };


    const handleChooseFileClick = () => {
        fileInputRef.current.click();

    };

    const handleFileChange = (event) => {
        const chosenFile = event.target.files[0];
        if (chosenFile) {
            setFile(chosenFile); // Save the chosen file
            setFileUploaded(false);
            toast.success('File chosen successfully, please click the upload button to update the table data.!');      // Reset file upload status
        }
    };

    const handleUploadFileClick = () => {
        if (file) {
            readExcelFile(file);
            setFileUploaded(true); // Set file upload status to true
        } else {
            toast.error('Please choose a file first');
        }
    };

    const readExcelFile = (file) => {
    const reader = new FileReader();
    reader.onload = (e) => {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: 'array' });
        const firstSheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[firstSheetName];
        const jsonData = XLSX.utils.sheet_to_json(worksheet, { defval: '' });

        const incompleteRowIndices = [];
        const invalidIdProofRowIndices = [];
        const invalidMobileRowIndices = [];      // ← new
        const skippedDuplicateRowIndices = [];
        const invalidIdNumberRowIndices = [];

        // Signatures of members already in the table (loaded from API, a prior upload, or manual add/edit)
        const existingSignatures = new Set(
            tableData
                .map((row) => getMemberSignature(row))
                .filter((sig) => sig !== '||')
        );
        const seenInFile = new Set();

        const processedData = jsonData.map((row, index) => {
            const hasEmptyRequiredField = Object.entries(row).some(([key, value]) => {
                if (key.toLowerCase() === 'middlename') return false;
                return value === null || value === undefined || value.toString().trim() === '';
            });

            if (hasEmptyRequiredField) {
                incompleteRowIndices.push(index + 2);
            }

            // Mobile number length validation                      ← new block
            const mobileValue = (row['Mobile Number(eg:1234567890)'] || '').toString().trim();
            if (mobileValue && (mobileValue.length > 10 || mobileValue.length < 10)) {
                invalidMobileRowIndices.push(index + 2);
            }

            const idNumberValue = (row['ID Number(eg:123322442442)'] || '').toString().trim();
            if (idNumberValue && idNumberValue.length !== 4) {
                invalidIdNumberRowIndices.push(index + 2);
            }

            const idProofValue = (row['ID Proof(eg:Passport)'] || '').toString().trim();
            const matchedIdProof = idProofTypes.find(
                (type) => (type.idProofDescription || '').toLowerCase() === idProofValue.toLowerCase()
            );

            if (idProofValue && !matchedIdProof) {
                invalidIdProofRowIndices.push(index + 2);
            }

            // Duplicate detection (skip duplicates instead of blocking the whole upload)
            const signature = getMemberSignature(row);
            let isDuplicate = false;
            if (signature !== '||') {
                if (seenInFile.has(signature) || existingSignatures.has(signature)) {
                    isDuplicate = true;
                    skippedDuplicateRowIndices.push(index + 2);
                } else {
                    seenInFile.add(signature);
                }
            }

            return {
                ...row,
                'ID Proof(eg:Passport)': matchedIdProof?.idProofDescription || row['ID Proof(eg:Passport)'],
                idProofType: matchedIdProof ? matchedIdProof.id : null,
                __isDuplicate: isDuplicate,
            };
        });

        if (incompleteRowIndices.length > 0) {
            toast.error(
                `Rows ${incompleteRowIndices.join(', ')} contain missing required fields. Please fill all fields except middle name.`
            );
            return;
        }

        // ← new error block
        if (invalidMobileRowIndices.length > 0) {
            toast.error(
                `Rows ${invalidMobileRowIndices.join(', ')} contains a mobile number that is either less than or greater than 10 digits.`
            );
            return;
        }

        if (invalidIdNumberRowIndices.length > 0) {
            toast.error(
                `Rows ${invalidIdNumberRowIndices.join(', ')} contain an ID Number that is not exactly 4 digits. Please enter Last 4 characters.`
            );
            return;
        }

        if (invalidIdProofRowIndices.length > 0) {
            toast.error(
                `Rows ${invalidIdProofRowIndices.join(', ')} have an ID Proof value that doesn't match any valid ID Proof type. Please use the dropdown values from the Sample Template.`
            );
            return;
        }

        const uniqueRows = processedData
            .filter((row) => !row.__isDuplicate)
            .map(({ __isDuplicate, ...rest }) => rest);

        if (skippedDuplicateRowIndices.length > 0) {
            toast.error(
                `Rows ${skippedDuplicateRowIndices.join(', ')} are duplicates (matching First Name, Last Name and Email) and were skipped.`
            );
        }

        setTableData((prevData) => [...prevData, ...uniqueRows]);
        setFileUploaded(true);
        toast.success('Data updated successfully');
    };
    reader.readAsArrayBuffer(file);
};


    const handleSampleTemplateClick = async () => {
        // Ensure latest data — in case state hasn't populated yet
        let genderList = ["Male", "Female", "Other"];
        let nationalityList = nationalityListM.map((n) => n.name).filter(Boolean);
        let idProofList = idProofTypes.map((t) => t.idProofDescription).filter(Boolean);

        if (nationalityList.length === 0) {
            try {
                const nation = await axiosInstance.get('/Nationality');
                nationalityList = (nation.data || []).map((n) => n.name).filter(Boolean);
            } catch (error) {
                console.error('Error fetching nationality for template:', error);
            }
        }

        if (idProofList.length === 0) {
            try {
                const types = await axiosInstance.get('/idproof');
                idProofList = (types.data || []).map((t) => t.idProofDescription).filter(Boolean);
            } catch (error) {
                console.error('Error fetching id proof types for template:', error);
            }
        }

        // Fallbacks so dropdowns never end up empty/broken if APIs return nothing
        if (genderList.length === 0) genderList = ["Male", "Female", "Other"];
        if (nationalityList.length === 0) nationalityList = ["N/A"];
        if (idProofList.length === 0) idProofList = ["N/A"];

        const workbook = new ExcelJS.Workbook();
        const sheet = workbook.addWorksheet('SampleTemplate');
        const listSheet = workbook.addWorksheet('Lists'); // helper sheet holding dropdown values

        const headers = [
            "firstName",
            "middleName",
            "lastName",
            "email",
            "company",
            "gender",
            "nationality",
            "Mobile Number(eg:1234567890)",
            "ID Proof(eg:Passport)",
            "ID Number(eg:123322442442)"
        ];
        sheet.addRow(headers);
        sheet.addRow([]); // blank row 2 for user to fill in

        // Write list values onto the helper sheet (one list per column)
        genderList.forEach((val, i) => { listSheet.getCell(i + 1, 1).value = val; });       // Column A: Gender
        nationalityList.forEach((val, i) => { listSheet.getCell(i + 1, 2).value = val; });  // Column B: Nationality
        idProofList.forEach((val, i) => { listSheet.getCell(i + 1, 3).value = val; });      // Column C: ID Proof

        listSheet.state = 'hidden'; // hide the helper sheet from the user (more widely supported than veryHidden)

        const maxRows = 200; // apply dropdown validation to first 200 data rows

        // IMPORTANT: use sheet.dataValidations.add with a single range per column.
        // Looping cell-by-cell with cell.dataValidation produces fragmented/overlapping
        // sqref ranges that Excel tolerates but ONLYOFFICE silently drops.
        sheet.dataValidations.add(`F2:F${maxRows + 1}`, {
            type: 'list',
            allowBlank: true,
            formulae: [`Lists!$A$1:$A$${genderList.length}`],
            showErrorMessage: true,
            errorTitle: 'Invalid Gender',
            error: 'Please select a value from the dropdown list.'
        });

        sheet.dataValidations.add(`G2:G${maxRows + 1}`, {
            type: 'list',
            allowBlank: true,
            formulae: [`Lists!$B$1:$B$${nationalityList.length}`],
            showErrorMessage: true,
            errorTitle: 'Invalid Nationality',
            error: 'Please select a value from the dropdown list.'
        });

        sheet.dataValidations.add(`I2:I${maxRows + 1}`, {
            type: 'list',
            allowBlank: true,
            formulae: [`Lists!$C$1:$C$${idProofList.length}`],
            showErrorMessage: true,
            errorTitle: 'Invalid ID Proof',
            error: 'Please select a value from the dropdown list.'
        });

        // Basic column widths for readability
        sheet.columns = headers.map(() => ({ width: 22 }));

        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: 'application/octet-stream' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = 'SampleTemplate.xlsx';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
    };
    useEffect(() => {
        const getIdProofTypes = async () => {
            try {
                const types = await axiosInstance.get("/idproof");
                setIdProofTypes(types.data);
            } catch (error) {
                console.error('Error fetching visitor types:', error);
            }
        };
        console.log("formattedData", formattedData);
        console.log("formattedData", formDataAdditional);
        const getNationality = async () => {
            try {
                const nation = await axiosInstance.get('/Nationality');
                const filteredActiveNations = nation.data.filter(n => n.isActive && !n.isBlackListed);
                setNationalityListM(filteredActiveNations);
                const defaultNationality = nation.data.find((n) => n.isDefault);
                if (defaultNationality) {
                    setMemberDetails((prev) => ({
                        ...prev,
                        nationality: defaultNationality.name,
                    }));
                    setNationalityCodeM(defaultNationality?.nationalityCode || '');

                }


            } catch (error) {
                console.error('Error fetching meeting venues:', error);
            }
        };
        const getMemberDetails = async () => {
            const responseGroupCheckin = await axiosInstance.get(`/GroupMember/${formDataAdditional.id}`);
            console.log("responseGroupCheckin", responseGroupCheckin);
            const memberData = responseGroupCheckin.data;

            // Transform data to match table structure
            const transformedData = memberData.map((member) => ({
                id: member?.id || 0, // ← Keep the ID internally
                firstName: member?.firstName || '',
                middleName: member?.middleName || '',
                lastName: member?.lastName || '',
                email: member?.groupMemberEmail || '',
                company: member?.company || '',
                gender: member?.gender || '',
                nationality: member?.nationality || '',
                'Mobile Number(eg:1234567890)': member?.visitorMobile || '',
                'ID Proof(eg:Passport)': member?.idProofName || '',
                idProofType: member?.idProofType || null,
                'ID Number(eg:123322442442)': member?.idProofNo || '',
                profileImage: member?.photo
                    ? `data:image/jpeg;base64,${member.photo}`
                    : '', // Convert base64 string to image URL
            }));

            setTableData(transformedData || []);


        }
        getMemberDetails();
        getNationality();
        getIdProofTypes();

    }, []);

    const [isSubmitted, setIsSubmitted] = useState(false);


    const handleSubmitClick = async () => {
        console.log("formattedData", formattedData);
        console.log('Table Data:', tableData);
        setLoading(true);
        if (tableData.length === 0) {
            toast.error("Please add at least one group member before submitting!");
            setLoading(false);
            return; // Exit the function if no members are added
        }



        const missingImages = tableData.some(row => !row.profileImage);
        // if (missingImages) {
        //   // Show a toast message if there are missing images
        //   toast.error("Please upload images for all members");
        //   return; // Prevent further action
        // }

        const empID = localStorage.getItem('employeeId');
        const formData = formattedData
        const addformData = formDataAdditional
        const formatDateForApi = (date) => {
            return moment(date).format('YYYY-MM-DDTHH:mm:ss.SSS[Z]');
        };
        const getPhotoFromProfileImage = (profileImage) => {
            return profileImage ? profileImage.split(',')[1] : '';
        };
        const date = new Date();
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = String(date.getSeconds()).padStart(2, '0');

        const checkInDateTime = `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
        const requestData = [
            ...tableData.map((row) => ({
                id: row?.id || row['id'] || 0, // Use preserved ID if exists, else 0 for new
                groupAppointmentId: addformData.id,
                groupMemberName: row['firstName'] || '',
                visitorMobile: String(row['Mobile Number(eg:1234567890)'] || ''),
                groupMemberEmail: row['email'] || '',
                company: row['company'] || '',
                idProofName: row['ID Proof(eg:Passport)'] || '',
                idProofNo: String(row['ID Number(eg:123322442442)'] || ''),
                idProofType: parseInt(row?.idProofType || null),
                photo: getPhotoFromProfileImage(row?.profileImage),
                country: "",
                firstName: row['firstName'] || '',
                middleName: row['middleName'] || '',
                lastName: row['lastName'] || '',
                nationality: row['nationality'] || '',
                gender: row['gender'] || '',
                isVisitConfirmed: true,
                // nationalityCode:"0"

            })),
        ];

        console.log("Request Data:", requestData);
        try {
            const response = await axiosInstance.post('/GroupAppointment/InsertAndUpdateGroupMembers', requestData);
            console.log("response", response);
            if (response.data == "-1") {
                toast.error('appointment already exists')
                setLoading(false);

                // return
            }
            if (response.status === 200) {
                setLoading(false);
                setIsSubmitted(true);


                toast.success(response.data.message, {
                    toastId: 'summary-toast',  // optional ID to avoid duplicate toasts
                    onClose: () => {
                        toast.success("Form Submitted successfully. Please check the Email for Appointment!");

                        setTimeout(() => {
                            navigate('/form-submitted');
                        }, 3000); // Delay navigation if needed after second toast
                    }
                });
                // toast.success("Form Submitted successfully Please check the Email for Appointment!")
                // setLoading(false);


                // // Delay navigation to ensure the toast is displayed
                // setTimeout(() => {
                //     navigate('/form-submitted');
                // }, 3000); // Adjust the delay as needed (3000ms = 3 seconds)
            }

        } catch (error) {
            setLoading(false);

            console.error('Error submitting form:', error);
            toast.error("Something went wrong. Please try again.");

        }


    };
    const [showAddMemberPopup, setShowAddMemberPopup] = useState(false);
    const [memberDetails, setMemberDetails] = useState({
        id: '',
        firstName: '',
        middleName: '',
        lastName: '',
        email: '',
        company: '',
        gender: '',
        nationality: '',
        mobileNumber: '',
        idProof: '',
        idProofType: null,
        idNumber: ''
    });
    const [nationalityCodeM, setNationalityCodeM] = useState('');


    const addMemberPopup = () => {
        setMemberDetails({
            firstName: '',
            middleName: '',
            lastName: '',
            email: '',
            company: '',
            gender: '',
            nationality: '',
            mobileNumber: '',
            idProof: '',
            idNumber: '',
        });
        setNationalityCodeM(''); // reset nationality code if used

        setShowAddMemberPopup(true);
        const getNationality = async () => {
            try {
                const nation = await axiosInstance.get('/Nationality');
                const filteredActiveNationalities = nation.data.filter((n) => n.isActive && !n.isBlackListed);
                setNationalityListM(filteredActiveNationalities);
                const defaultNationality = nation.find((n) => n.isDefault);
                if (defaultNationality) {
                    setMemberDetails((prev) => ({
                        ...prev,
                        nationality: defaultNationality.name,
                    }));
                    setNationalityCodeM(defaultNationality?.nationalityCode || '');

                }


            } catch (error) {
                console.error('Error fetching meeting venues:', error);
            }
        };
        getNationality();

    }
    const handleAddMember = () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(memberDetails.email)) {
        toast.error("Please enter a valid email");
        return;
    }

    if (!memberDetails.firstName || !memberDetails.lastName || !memberDetails.gender || !memberDetails.company || !memberDetails.email || !memberDetails.nationality || !memberDetails.mobileNumber || !memberDetails.idProof || !memberDetails.idNumber) {
        toast.error("Please fill the all fields")
        return;
    }

    // Duplicate check against members already in the table
    const newSignature = `${normalizeValue(memberDetails.firstName)}|${normalizeValue(memberDetails.lastName)}|${normalizeValue(memberDetails.email)}`;
    const isDuplicate = tableData.some((row) => getMemberSignature(row) === newSignature);

    if (isDuplicate) {
        toast.error("A member with the same First Name, Last Name and Email has already been added.");
        return;
    }

    setTableData((prevData) => [
        ...prevData,
        {
            'id': 0,
            'firstName': memberDetails.firstName,
            'middleName': memberDetails.middleName,
            'lastName': memberDetails.lastName,
            'email': memberDetails.email,
            'company': memberDetails.company,
            'gender': memberDetails.gender,
            'nationality': memberDetails.nationality,
            'Mobile Number(eg:1234567890)': memberDetails.mobileNumber,
            'ID Proof(eg:Passport)': memberDetails.idProof,
            'idProofType': memberDetails.idProofType,
            'ID Number(eg:123322442442)': memberDetails.idNumber
        }
    ]);

    setMemberDetails({ firstName: '', lastName: '', middleName: '', gender: '', email: '', company: '', nationality: '', mobileNumber: '', idProof: '', idNumber: '' });
    setShowAddMemberPopup(false);
};
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        console.log("name", name);
        console.log("value", value);

        // Special handling for ID Proof dropdown
        if (name === "idProof") {
            const selected = idProofTypes.find(t => t.id == value);
            setMemberDetails(prev => ({
                ...prev,
                idProof: selected?.idProofDescription,
                idProofType: parseInt(value)
            }));
            return;
        }
        setMemberDetails((prev) => ({ ...prev, [name]: value }));
    };
    const [idProofTypes, setIdProofTypes] = useState([]);


    const [cameraStates, setCameraStates] = useState(Array(tableData.length).fill(false));
    const [buttonLabels, setButtonLabels] = useState(Array(tableData.length).fill('Take photo'));
    useEffect(() => {
        setButtonLabels(Array(cameraStates.length).fill('Take photo'));
    }, [cameraStates.length]);
    const handleCapture = async (index) => {
        const updatedCameraStates = [...cameraStates];
        const updatedButtonLabels = [...buttonLabels];

        // Toggle camera state for the specific row
        if (!updatedCameraStates[index]) {
            // If the camera is off, turn it on
            updatedCameraStates[index] = true;
            updatedButtonLabels[index] = "Capture";
        } else {
            // If the camera is on, capture the image
            const imageSrc = webcamRef.current.getScreenshot();

            if (imageSrc) {
                // Create an image element from the captured screenshot
                const img = new Image();
                img.src = imageSrc;

                img.onload = async () => {
                    // Create a canvas for image processing
                    const canvas = document.createElement("canvas");
                    canvas.width = img.width;
                    canvas.height = img.height;
                    const ctx = canvas.getContext("2d");

                    // Draw the captured image onto the canvas
                    ctx.drawImage(img, 0, 0, img.width, img.height);
                    const faceDetection = new FaceDetection({
                        locateFile: (file) =>
                            `https://cdn.jsdelivr.net/npm/@mediapipe/face_detection/${file}`,
                    });

                    faceDetection.setOptions({
                        model: 'short', // fast + accurate model
                        minDetectionConfidence: 0.5,
                    });

                    await faceDetection.initialize();

                    // Run face detection
                    const detectionResults = await new Promise((resolve) => {
                        faceDetection.onResults(resolve);
                        faceDetection.send({ image: img });
                    });

                    // Check if face is detected
                    if (!detectionResults.detections || detectionResults.detections.length === 0) {
                        toast.error("Human face not detected");
                        return;
                    }

                    // Initialize MediaPipe Selfie Segmentation
                    const segmentation = new SelfieSegmentation({
                        locateFile: (file) =>
                            `https://cdn.jsdelivr.net/npm/@mediapipe/selfie_segmentation/${file}`,
                    });

                    segmentation.setOptions({
                        modelSelection: 1, // General-purpose segmentation model
                    });

                    // Perform segmentation to remove the background
                    await segmentation.initialize();
                    const results = await new Promise((resolve) => {
                        segmentation.onResults(resolve);
                        segmentation.send({ image: img });
                    });

                    // Create a new canvas for output
                    const outputCanvas = document.createElement("canvas");
                    outputCanvas.width = img.width;
                    outputCanvas.height = img.height;
                    const outputCtx = outputCanvas.getContext("2d");

                    // Draw the original image onto the output canvas
                    outputCtx.drawImage(img, 0, 0, img.width, img.height);

                    // Apply the segmentation mask to retain only the human face
                    outputCtx.globalCompositeOperation = "destination-in";
                    outputCtx.drawImage(
                        results.segmentationMask,
                        0,
                        0,
                        img.width,
                        img.height
                    );

                    // Apply a transparent background
                    outputCtx.globalCompositeOperation = "destination-over";
                    outputCtx.fillStyle = "white";  // Change to white background
                    outputCtx.fillRect(0, 0, img.width, img.height);

                    // Convert the processed image to base64
                    const processedBase64Image = outputCanvas.toDataURL("image/jpeg");

                    // Update the table data with the processed image
                    setTableData((prevData) =>
                        prevData.map((row, rowIndex) =>
                            rowIndex === index ? { ...row, profileImage: processedBase64Image } : row
                        )
                    );
                };
            }

            // Turn off the camera and reset button label
            updatedCameraStates[index] = false;
            updatedButtonLabels[index] = "Take photo";
        }

        // Update state with new values
        setCameraStates(updatedCameraStates);
        setButtonLabels(updatedButtonLabels);
    };
    const resizeAndCompress = async (canvas) => {
        const targetWidth = 320;
        const targetHeight = 240;

        const resizedCanvas = document.createElement("canvas");
        resizedCanvas.width = targetWidth;
        resizedCanvas.height = targetHeight;

        const resizedCtx = resizedCanvas.getContext("2d");
        resizedCtx.drawImage(canvas, 0, 0, targetWidth, targetHeight);

        return resizedCanvas.toDataURL("image/jpeg", 0.3); // 30% quality
    };

    const processImageWithSegmentation = async (image) => {
        const canvas = document.createElement("canvas");
        canvas.width = image.width;
        canvas.height = image.height;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(image, 0, 0, image.width, image.height);

        const segmentation = new SelfieSegmentation({
            locateFile: (file) =>
                `https://cdn.jsdelivr.net/npm/@mediapipe/selfie_segmentation/${file}`,
        });

        segmentation.setOptions({ modelSelection: 1 });
        await segmentation.initialize();

        const results = await new Promise((resolve) => {
            segmentation.onResults(resolve);
            segmentation.send({ image });
        });

        const outputCanvas = document.createElement("canvas");
        outputCanvas.width = image.width;
        outputCanvas.height = image.height;
        const outputCtx = outputCanvas.getContext("2d");

        outputCtx.drawImage(image, 0, 0, image.width, image.height);
        outputCtx.globalCompositeOperation = "destination-in";
        outputCtx.drawImage(results.segmentationMask, 0, 0);
        outputCtx.globalCompositeOperation = "destination-over";
        outputCtx.fillStyle = "#fff";
        outputCtx.fillRect(0, 0, image.width, image.height);

        return resizeAndCompress(outputCanvas);
    };

    const handleImageUpload = async (e, index) => {
        const file = e.target.files[0];
        if (!file || (file.type !== 'image/png' && file.type !== 'image/jpeg')) {
            toast.error('Please upload a PNG or JPEG image');
            return;
        }

        const reader = new FileReader();
        reader.onloadend = async () => {
            const img = new Image();
            img.src = reader.result;

            img.onload = async () => {
                const base64Image = await processImageWithSegmentation(img);
                setTableData((prevData) =>
                    prevData.map((row, rowIndex) =>
                        rowIndex === index ? { ...row, profileImage: base64Image } : row
                    )
                );
            };
        };

        reader.readAsDataURL(file);
    };



    // const handleImageUpload = (e, index) => {
    //     const file = e.target.files[0];
    //     if (file && file.type === 'image/jpeg') {
    //         const reader = new FileReader();
    //         reader.onload = () => {
    //             const img = new Image();
    //             img.src = reader.result;

    //             img.onload = () => {
    //                 // Create a canvas for image processing
    //                 const canvas = document.createElement("canvas");
    //                 const ctx = canvas.getContext("2d");

    //                 // Set new dimensions to resize to 640x480
    //                 const width = 640;
    //                 const height = 480;
    //                 canvas.width = width;
    //                 canvas.height = height;

    //                 // Draw the image onto the canvas with new dimensions
    //                 ctx.drawImage(img, 0, 0, width, height);

    //                 // Create the resized and compressed image in base64
    //                 const compressedBase64Image = canvas.toDataURL("image/jpeg", 0.5); // Quality: 0.5 (out of 1)

    //                 // Update the table data with the processed image
    //                 setTableData((prevData) =>
    //                     prevData.map((row, rowIndex) =>
    //                         rowIndex === index ? { ...row, profileImage: compressedBase64Image } : row
    //                     )
    //                 );
    //             };
    //         };
    //         reader.readAsDataURL(file); // Read as base64
    //     } else {
    //         alert('Please upload a jpeg image');
    //     }
    // };

    const webcamRef = useRef(null);
    const [isCameraOn, setIsCameraOn] = useState(false);
    const [buttonLabel, setButtonLabel] = useState('Take photo');
    const [profileImage, setProfileImage] = useState(null);
    const backtoForm = () => {
        navigate('/layout/GroupAppointment/GroupAppointment');

    }
    const [showEditMemberPopup, setShowEditMemberPopup] = useState(false);
    const [editIndex, setEditIndex] = useState(null);

    // New handler for editing member:
    const handleEditClick = (index) => {

        const selectedRow = tableData[index];
        console.log("selectedRow", selectedRow);

        setMemberDetails({

            id: selectedRow.id,
            firstName: selectedRow.firstName || '',
            middleName: selectedRow.middleName || '',
            lastName: selectedRow.lastName || '',
            email: selectedRow.email || '',
            company: selectedRow.company || '',
            gender: selectedRow.gender || '',
            nationality: selectedRow.nationality || '',
            mobileNumber: selectedRow['Mobile Number(eg:1234567890)'] || '',
            idProof: selectedRow['ID Proof(eg:Passport)'] || '',
            idNumber: selectedRow['ID Number(eg:123322442442)'] || ''
        });
        setEditIndex(index);
        setShowEditMemberPopup(true);
        const getNationality = async () => {
            try {
                const nation = await axiosInstance.get('/Nationality');
                const fliteredActiveNations = nation.data.filter(n => n.isActive && !n.isBlackListed);
                setNationalityListM(fliteredActiveNations);
                const defaultNationality = nation.data.find((n) => n.isDefault);
                if (defaultNationality) {
                    setMemberDetails((prev) => ({
                        ...prev,
                        nationality: defaultNationality.name,
                    }));
                    setNationalityCodeM(defaultNationality?.nationalityCode || '');

                }


            } catch (error) {
                console.error('Error fetching meeting venues:', error);
            }
        };
        getNationality();
    };

    const handleUpdateMember = () => {
    if (!memberDetails.firstName || !memberDetails.lastName || !memberDetails.gender || !memberDetails.email || !memberDetails.company || !memberDetails.nationality || !memberDetails.mobileNumber || !memberDetails.idProof || !memberDetails.idNumber) {
        toast.error("Please fill all fields");
        return;
    }

    // Duplicate check against other members in the table (excluding the row being edited)
    const updatedSignature = `${normalizeValue(memberDetails.firstName)}|${normalizeValue(memberDetails.lastName)}|${normalizeValue(memberDetails.email)}`;
    const isDuplicate = tableData.some(
        (row, idx) => idx !== editIndex && getMemberSignature(row) === updatedSignature
    );

    if (isDuplicate) {
        toast.error("Another member with the same First Name, Last Name and Email already exists.");
        return;
    }

    const updatedData = [...tableData];
    updatedData[editIndex] = {
        'id': memberDetails.id,
        'firstName': memberDetails.firstName,
        'middleName': memberDetails.middleName,
        'lastName': memberDetails.lastName,
        'email': memberDetails.email,
        'company': memberDetails.company,
        'gender': memberDetails.gender,
        'nationality': memberDetails.nationality,
        'Mobile Number(eg:1234567890)': memberDetails.mobileNumber,
        'ID Proof(eg:Passport)': memberDetails.idProof,
        'idProofType': memberDetails?.idProofType,
        'ID Number(eg:123322442442)': memberDetails.idNumber,
        profileImage: tableData[editIndex]?.profileImage || null,
    };

    setTableData(updatedData);
    setShowEditMemberPopup(false);
    setEditIndex(null);
};

    const [transportVendorFileName, setTransportVendorFileName] = useState("");
    const [transportVendorFileBase64, setTransportVendorFileBase64] = useState("");


    const fileToBase64 = (file) => {
        return new Promise((resolve, reject) => {
            if (!file) {
                resolve(null);
                return;
            }

            const reader = new FileReader();
            reader.onload = () => resolve(reader.result.split(',')[1]); // remove "data:...base64,"
            reader.onerror = reject;
            reader.readAsDataURL(file);
        });
    };



    return (
        <Container>
            {loading && <Loader />}
            <ToastContainer />
            <Header>
                <Heading>Group Member Details</Heading>
                {/* <Button onClick={backtoForm}>Back</Button> */}

                <Button onClick={handleSubmitClick} disabled={isSubmitted || loading}>
                    {loading ? 'Submitting' : 'Submit'}
                </Button>

            </Header>

            <Card>
                {/* Left Side of the Card */}
                <CardLeft>
                    <CardItem>
                        <CardLabel>Group Leader Name:</CardLabel>
                        <CardValue>{formattedData?.firstName}</CardValue>
                    </CardItem>
                    <CardItem>
                        <CardLabel>Leader Mobile Number:</CardLabel>
                        <CardValue>{formattedData.visitorMobile}</CardValue>
                    </CardItem>
                    <CardItem>
                        <CardLabel>Visitor Email:</CardLabel>
                        <CardValue>{formattedData.visitorEmail}</CardValue>
                    </CardItem>
                </CardLeft>
                <CardCenter>
                    <CardItem>
                        <CardLabel>Meeting Venue:</CardLabel>
                        <CardValue>{formattedData.meetingVenue}</CardValue>
                    </CardItem>
                    <CardItem>
                        <CardLabel>Meeting On:</CardLabel>
                        <CardValue>{new Intl.DateTimeFormat('en-CA', {
                            year: 'numeric',
                            month: '2-digit',
                            day: '2-digit',
                            hour: '2-digit',
                            minute: '2-digit',
                            second: '2-digit',
                            hour12: false
                        }).format(new Date(formattedData.meetingFrom))}</CardValue>
                    </CardItem>
                    <CardItem>
                        <CardLabel>Meeting To:</CardLabel>
                        <CardValue>{new Intl.DateTimeFormat('en-CA', {
                            year: 'numeric',
                            month: '2-digit',
                            day: '2-digit',
                            hour: '2-digit',
                            minute: '2-digit',
                            second: '2-digit',
                            hour12: false
                        }).format(new Date(formattedData.meetingTo))}</CardValue>
                    </CardItem>
                </CardCenter>


                {/* Right Side of the Card */}
                <CardRight>
                    <CardItem>
                        <CardLabel>Gate:</CardLabel>
                        <CardValue>{formattedData.gate}</CardValue>
                    </CardItem>
                    <CardItem>
                        <CardLabel>Building:</CardLabel>
                        <CardValue>{formattedData.building}</CardValue>
                    </CardItem>
                    <CardItem>
                        <CardLabel>Visitor Company:</CardLabel>
                        <CardValue>{formattedData.company}</CardValue>
                    </CardItem>
                </CardRight>
            </Card>
            <ButtonsContainer>
                <ButtonGroupLeft>
                    <Button onClick={handleChooseFileClick}>Choose File</Button>
                    <input
                        type="file"
                        ref={fileInputRef}
                        style={{ display: 'none' }}
                        accept=".xlsx,.xls"
                        onChange={handleFileChange}
                    />
                    <Button onClick={handleUploadFileClick}>Upload File</Button>
                    <Button onClick={handleSampleTemplateClick}>Sample Template</Button>
                    <Button onClick={addMemberPopup}>Add Member</Button>

                </ButtonGroupLeft>
                <ButtonGroupRight>
                    {/* <Button onClick={handleSubmitClick}>Submit</Button> Enable Submit only after file upload */}
                    {/* <Button onClick={handleSubmitClick} disabled={isSubmitted || loading}>
                            {loading ? 'Submitting' : 'Submit'}
                        </Button> */}
                </ButtonGroupRight>
            </ButtonsContainer>
            <ScrollableTableContainer>
                <TableContainer>
                    <Table>
                        <TableHeader>
                            <TableRow>
                                <TableHeaderCell>First Name</TableHeaderCell>
                                <TableHeaderCell>Middle Name</TableHeaderCell>
                                <TableHeaderCell>Last Name</TableHeaderCell>
                                <TableHeaderCell>email</TableHeaderCell>
                                <TableHeaderCell>Company</TableHeaderCell>
                                <TableHeaderCell>Gender </TableHeaderCell>
                                <TableHeaderCell>Nationality</TableHeaderCell>
                                <TableHeaderCell>Visitor Mobile</TableHeaderCell>
                                <TableHeaderCell>Id Proof Type</TableHeaderCell>
                                <TableHeaderCell>Id Proof Number</TableHeaderCell>
                                <TableHeaderCell>Group Member Photo</TableHeaderCell> {/* Add Action Column */}
                                <TableHeaderCell>Action</TableHeaderCell> {/* Add Action Column */}

                            </TableRow>
                        </TableHeader>
                        <TableBody>
                            {tableData.map((row, index) => (
                                <TableRow key={index}>
                                    <TableCell>{row['firstName'] || ''}</TableCell>
                                    <TableCell>{row['middleName'] || ''}</TableCell>
                                    <TableCell>{row['lastName'] || ''}</TableCell>
                                    <TableCell>{row['email'] || ''}</TableCell>
                                    <TableCell>{row['company'] || ''}</TableCell>
                                    <TableCell>{row['gender'] || ''}</TableCell>
                                    <TableCell>{row['nationality'] || ''}</TableCell>
                                    <TableCell>{row['Mobile Number(eg:1234567890)'] || ''}</TableCell>
                                    <TableCell>{row['ID Proof(eg:Passport)'] || ''}</TableCell>
                                    <TableCell>{row['ID Number(eg:123322442442)'] || ''}</TableCell>
                                    <TableCell> {/* Action Cell */}
                                        <Circle>
                                            <WebcamContainer>
                                                {cameraStates[index] && (
                                                    <Webcam
                                                        audio={false}
                                                        ref={webcamRef}
                                                        screenshotFormat="image/jpeg"
                                                        width="100%"
                                                        height="100%"
                                                        videoConstraints={{
                                                            width: 200,
                                                            height: 200,
                                                            facingMode: 'user',
                                                        }}
                                                    />
                                                )}
                                                {!cameraStates[index] && row.profileImage && (
                                                    <img
                                                        src={row.profileImage}
                                                        alt="Profile"
                                                        style={{ width: '100%', height: '100%', borderRadius: '50%' }}
                                                    />
                                                )}
                                                {!cameraStates[index] && !row.profileImage && (
                                                    <ProfileIcon>
                                                        <User size={20} />
                                                    </ProfileIcon>
                                                )}
                                            </WebcamContainer>
                                        </Circle>
                                        <ButtonRow>
                                            <PhotoButton onClick={() => handleCapture(index)}>
                                                Take Photo
                                            </PhotoButton>
                                            <ActionButton>
                                                <label htmlFor={`upload-button-${index}`} style={{ cursor: 'pointer', fontSize: '9px' }}>
                                                    Upload images
                                                </label>
                                                <input
                                                    type="file"
                                                    id={`upload-button-${index}`}
                                                    style={{ display: 'none' }}
                                                    accept="image/png, image/jpeg"
                                                    onChange={(e) => handleImageUpload(e, index)}
                                                />
                                            </ActionButton>
                                        </ButtonRow>
                                    </TableCell>
                                    <TableCell>
                                        <IconWrapper onClick={() => handleEditClick(index)}>
                                            <FiEdit />
                                        </IconWrapper>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </ScrollableTableContainer>


            {showAddMemberPopup && (
                <Popup>
                    <PopupText>Add Member</PopupText>

                    <LabelValueContainer>
                        <Label> First Name:<Asterisk>*</Asterisk></Label>

                        <Value>
                            <Input
                                name="firstName" // Added the name attribute here
                                type="text"

                                placeholder="Enter First Name"
                                value={memberDetails.firstName}
                                onChange={handleInputChange}
                            />
                        </Value>

                    </LabelValueContainer>
                    <LabelValueContainer>
                        <Label> Middle Name:</Label>

                        <Value>
                            <Input
                                name="middleName" // Added the name attribute here
                                type="text"

                                placeholder="Enter Middle Name"
                                value={memberDetails.middleName}
                                onChange={handleInputChange}
                            />
                        </Value>

                    </LabelValueContainer>
                    <LabelValueContainer>
                        <Label> Last Name:<Asterisk>*</Asterisk></Label>

                        <Value>
                            <Input
                                name="lastName" // Added the name attribute here
                                type="text"

                                placeholder="Enter Last Name"
                                value={memberDetails.lastNameName}
                                onChange={handleInputChange}
                            />
                        </Value>

                    </LabelValueContainer>
                    <LabelValueContainer>
                        <Label>
                            Email:<Asterisk>*</Asterisk>
                        </Label>

                        <Value>
                            <Input
                                name="email"
                                type="email"  // Changed from text to email
                                placeholder="Enter Email"
                                value={memberDetails.email}
                                onChange={handleInputChange}
                                required // Optional: makes the field mandatory
                                pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$"
                                title="Please enter a valid email address"
                            />
                        </Value>
                    </LabelValueContainer>

                    <LabelValueContainer>
                        <Label> Company:<Asterisk>*</Asterisk></Label>

                        <Value>
                            <Input
                                name="company" // Added the name attribute here
                                type="text"

                                placeholder="Enter Company Name"
                                value={memberDetails.company}
                                onChange={handleInputChange}
                            />
                        </Value>

                    </LabelValueContainer>
                    <LabelValueContainer>
                        <Label>Gender:<Asterisk>*</Asterisk></Label>
                        <Value>
                            <Dropdown
                                name="gender"
                                value={memberDetails.gender}
                                onChange={handleInputChange}
                            >
                                <option value="">Select Gender</option>
                                <option value="Male">Male</option>
                                <option value="Female">Female</option>
                                <option value="Other">Other</option>
                            </Dropdown>
                        </Value>
                    </LabelValueContainer>
                    <LabelValueContainer>
                        <Label>Nationality:<Asterisk>*</Asterisk></Label>
                        <Value>
                            <Dropdown
                                name="nationality"
                                value={memberDetails.nationality}
                                onChange={(e) => {
                                    const selectedNationality = nationalityListM.find(
                                        (n) => n.name === e.target.value
                                    );
                                    setMemberDetails({
                                        ...memberDetails,
                                        nationality: e.target.value,
                                        mobileNumber: '',
                                    });
                                    setNationalityCodeM(selectedNationality?.nationalityCode || '');

                                }}
                            >
                                <option value="">Select Nationality</option>
                                {nationalityListM.map((nationality) => (
                                    <option
                                        key={nationality.id}
                                        value={nationality.name}
                                        disabled={nationality.isBlackListed}
                                    >
                                        {nationality.name}
                                    </option>
                                ))}
                            </Dropdown>
                        </Value>
                    </LabelValueContainer>
                    <LabelValueContainer>
                        <Label>Mobile Number:<Asterisk>*</Asterisk></Label>
                        <Value>
                            <Input
                                name="mobileNumber" // Added the name attribute here
                                type="text"
                                maxLength={nationalityCodeM === "91" ? 10 : 15}
                                placeholder="Enter Mobile Number"

                                value={memberDetails.mobileNumber}
                                onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
                                pattern="[0-9]*" // Allows only numbers
                                onChange={handleInputChange}
                            />

                        </Value>
                    </LabelValueContainer>

                    <LabelValueContainer>
                        <Label>ID Proof:<Asterisk>*</Asterisk></Label>
                        <Value>
                            <Dropdown
                                name="idProof" // Ensure name matches the state property
                                value={memberDetails.idProofType} // Bind value to state
                                onChange={handleInputChange}
                                style={{ fontSize: "12px" }}
                            >
                                <option value="">Select ID Proof</option>
                                {idProofTypes.map((type) => (
                                    <option key={type.id} value={type.id}>
                                        {type.idProofDescription}
                                    </option>
                                ))}
                            </Dropdown>

                        </Value>
                    </LabelValueContainer>



                    <LabelValueContainer>
                        <Label>  Id Number: <Asterisk>*</Asterisk></Label>
                        <Value>
                            <Input
                                name="idNumber" // Added the name attribute here
                                type="text"
                                maxLength={4}
                                placeholder="Enter ID Number"
                                value={memberDetails.idNumber}
                                onChange={(e) => {
                                    const regex = /^[a-zA-Z0-9]*$/; // Allows only alphanumeric characters
                                    if (regex.test(e.target.value)) {
                                        handleInputChange(e); // Call the original handler if valid
                                    }
                                }}
                            />
                        </Value>

                    </LabelValueContainer>

                    <ButtonContainer>
                        <PopupButton onClick={() => setShowAddMemberPopup(false)} style={{ backgroundColor: 'red' }}>Cancel</PopupButton>
                        <PopupButton onClick={handleAddMember}>Add</PopupButton>
                    </ButtonContainer>
                </Popup>
            )}

            {showEditMemberPopup && (
                <Popup>
                    <PopupText>Update Member</PopupText>

                    <LabelValueContainer>
                        <Label> First Name: <Asterisk>*</Asterisk> </Label>

                        <Value>
                            <Input
                                name="firstName" // Added the name attribute here
                                type="text"

                                placeholder="Enter First Name"
                                value={memberDetails.firstName}
                                onChange={handleInputChange}
                            />
                        </Value>

                    </LabelValueContainer>
                    <LabelValueContainer>
                        <Label> Middle Name:</Label>

                        <Value>
                            <Input
                                name="middleName" // Added the name attribute here
                                type="text"

                                placeholder="Enter Middle Name"
                                value={memberDetails.middleName}
                                onChange={handleInputChange}
                            />
                        </Value>

                    </LabelValueContainer>
                    <LabelValueContainer>
                        <Label> Last Name:<Asterisk>*</Asterisk> </Label>

                        <Value>
                            <Input
                                name="lastName" // Added the name attribute here
                                type="text"

                                placeholder="Enter Last Name"
                                value={memberDetails.lastName}
                                onChange={handleInputChange}
                            />
                        </Value>

                    </LabelValueContainer>
                    <LabelValueContainer>
                        <Label>
                            Email:<Asterisk>*</Asterisk>
                        </Label>

                        <Value>
                            <Input
                                name="email"
                                type="email"  // Changed from text to email
                                placeholder="Enter Email"
                                value={memberDetails.email}
                                onChange={handleInputChange}
                                required // Optional: makes the field mandatory
                                pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$"
                                title="Please enter a valid email address"
                            />
                        </Value>
                    </LabelValueContainer>
                    <LabelValueContainer>
                        <Label> Company:<Asterisk>*</Asterisk> </Label>

                        <Value>
                            <Input
                                name="company" // Added the name attribute here
                                type="text"

                                placeholder="Enter Company Name"
                                value={memberDetails.company}
                                onChange={handleInputChange}
                            />
                        </Value>

                    </LabelValueContainer>
                    <LabelValueContainer>
                        <Label>Gender:<Asterisk>*</Asterisk> </Label>
                        <Value>
                            <Dropdown
                                name="gender"
                                value={memberDetails.gender}
                                onChange={handleInputChange}
                                style={{ width: '175px' }}
                            >
                                <option value="">Select Gender</option>
                                <option value="Male">Male</option>
                                <option value="Female">Female</option>
                                <option value="Other">Other</option>
                            </Dropdown>
                        </Value>
                    </LabelValueContainer>
                    <LabelValueContainer>
                        <Label>Nationality:<Asterisk>*</Asterisk> </Label>
                        <Value>
                            <Dropdown
                                name="nationality"
                                value={memberDetails.nationality}
                                style={{ width: '175px' }}

                                onChange={(e) => {
                                    const selectedNationality = nationalityListM.find(
                                        (n) => n.name === e.target.value
                                    );
                                    setMemberDetails({
                                        ...memberDetails,
                                        nationality: e.target.value,
                                        mobileNumber: '',
                                    });
                                    setNationalityCodeM(selectedNationality?.nationalityCode || '');

                                }}
                            >
                                <option value="">Select Nationality</option>
                                {nationalityListM.map((nationality) => (
                                    <option
                                        key={nationality.id}
                                        value={nationality.name}
                                        disabled={nationality.isBlackListed}
                                    >
                                        {nationality.name}
                                    </option>
                                ))}
                            </Dropdown>
                        </Value>
                    </LabelValueContainer>
                    <LabelValueContainer>
                        <Label>Mobile Number:<Asterisk>*</Asterisk> </Label>
                        <Value>
                            <Input
                                name="mobileNumber" // Added the name attribute here
                                type="text"
                                maxLength={nationalityCodeM === "91" ? 10 : 15}
                                placeholder="Enter Mobile Number"

                                value={memberDetails.mobileNumber}
                                onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
                                pattern="[0-9]*" // Allows only numbers
                                onChange={handleInputChange}
                            />

                        </Value>
                    </LabelValueContainer>

                    <LabelValueContainer>
                        <Label>ID Proof:<Asterisk>*</Asterisk> </Label>
                        <Value>
                            <Dropdown
                                name="idProof" // Ensure name matches the state property
                                value={memberDetails.Type} // Bind value to state
                                onChange={handleInputChange}
                                style={{ fontSize: "12px", width: '175px' }}
                            >
                                <option value="">Select ID Proof</option>
                                {idProofTypes.map((type) => (
                                    <option key={type.id} value={type.id}>
                                        {type.idProofDescription}
                                    </option>
                                ))}
                            </Dropdown>

                        </Value>
                    </LabelValueContainer>



                    <LabelValueContainer>
                        <Label>  Id Number:<Asterisk>*</Asterisk> </Label>
                        <Value>
                            <Input
                                name="idNumber" // Added the name attribute here
                                type="text"
                                maxLength={4}
                                placeholder="Enter ID Number"
                                value={memberDetails.idNumber}
                                onChange={(e) => {
                                    const regex = /^[a-zA-Z0-9]*$/; // Allows only alphanumeric characters
                                    if (regex.test(e.target.value)) {
                                        handleInputChange(e); // Call the original handler if valid
                                    }
                                }}
                            />
                        </Value>

                    </LabelValueContainer>

                    <ButtonContainer>
                        <PopupButton onClick={() => setShowEditMemberPopup(false)} style={{ backgroundColor: 'red' }}>Cancel</PopupButton>
                        <PopupButton onClick={handleUpdateMember}>Update</PopupButton>
                    </ButtonContainer>
                </Popup>
            )}
        </Container>
    );
};

export default GroupMemberApplicationPage;
